import { useState, useContext, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Alert,
  Card,
  Table,
  ButtonGroup,
  Modal,
  ProgressBar,
  Badge,
} from "react-bootstrap";

import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
import moment from "moment";
import { useParams } from "react-router-dom";
import { UserContext } from "../../common";
import RotaForm from "./RotaForm";
import RotaAssignment from "./RotaAssignment";
import RotaNote from "./RotaNote";
import ChoosePlans from "../../components/application/ChoosePlans";

import MessageModal from "../../components/MessageModal";

const Rota = (props) => {
  const viewOnly = _.get(props, "viewOnly", false);
  const { userData } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [rotaing, setRotaing] = useState(false);
  const [rotas, setRotas] = useState([]);
  const [rUsers, setRUsers] = useState([]);
  const [ruHolidays, setRUHolidays] = useState([]);
  const [branches, setBranches] = useState([]);
  const [orgMembers, setOrgMembers] = useState([]);
  const [mode, setMode] = useState(0);
  const [message, setMessage] = useState(false);
  const [filter, setFilter] = useState({
    op: viewOnly ? "anyone" : "self",
    member: 0,
    branch: 0,
    mode: 1,
  });
  const [dtFrom, setDtFrom] = useState(moment());
  const [showCopy, setShowCopy] = useState(false);
  const [notes, setNotes] = useState([]);
  const [showNote, setShowNote] = useState(false);
  const [confirmCopy, setConfirmCopy] = useState(false);

  const addToNotes = (note) => {
    let newNotes = { ...notes };
    newNotes = _.filter(
      newNotes,
      (nt) => parseInt(nt.id) !== parseInt(note.id),
    );
    newNotes.push(note);
    setNotes({ ...newNotes });
  };

  const fetchBranches = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchBranches?orgMembers=1"), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setBranches(res.data.branches);
          setOrgMembers(res.data.orgMembers);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const fetchRotas = (dir = 0) => {
    setLoading(true);
    var newDtFrom = moment(dtFrom);
    if (filter.mode == 2) {
      newDtFrom.add("day", dir);
    }
    let pvars = `?filter[op]=${filter.op}&filter[mode]=${filter.mode}`;
    pvars += `&filter[dtf]=${newDtFrom.format("YYYY-MM-DD")}`;
    pvars += `&filter[member]=${filter.member}`;
    pvars += `&filter[branch]=${filter.branch}`;

    axios
      .get(Utils.apiUrl("users/fetchrotas") + pvars, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setRotas(_.get(res, "data.rotas", []));
          setNotes(_.get(res, "data.rotanotes", []));
          setRUsers(_.get(res, "data.rotausers", []));
          setRUHolidays(_.get(res, "data.holidays", []));
          setShowCopy(parseInt(_.get(res, "data.prevCount", 0)) > 0);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const deleteRota = (rid) => {
    setLoading(true);

    axios
      .delete(Utils.apiUrl(`users/delrota/${rid}`), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        setMessage({
          type: res.data.success ? "info" : "error",
          message: _.isObject(res.data.message)
            ? Object.values(res.data.message).join(",")
            : res.data.message,
        });
        fetchRotas();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const deleteRotaAss = (rid) => {
    if (
      window.confirm("Are you sure to delete this Rota Assignment?") === false
    )
      return;
    setLoading(true);

    axios
      .delete(Utils.apiUrl(`users/delRotaAss/${rid}`), Utils.apiHeaders())
      .then((res) => {
        console.log(res);
        setLoading(false);
        setMessage({
          type: res.data.success ? "info" : "error",
          message: _.isObject(res.data.message)
            ? Object.values(res.data.message).join(",")
            : res.data.message,
        });
        fetchRotas();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(fetchRotas, [dtFrom, filter]);
  useEffect(fetchBranches, []);

  const afterSave = (res) => {
    setMessage({
      type: res.success ? "info" : "error",
      message: _.isObject(res.message)
        ? Object.values(res.message).join(",")
        : res.message,
    });
    if (res.success) {
      fetchRotas(-1);
    }
  };

  if (!_.get(userData, "is_rota", false) && !viewOnly) {
    return (
      <>
        {!userData.is_super_user && (
          <h1 className="alert alert-danger p-5 mt-5">No access!</h1>
        )}
        {userData.is_super_user && (
          <>
            <h1 className="alert alert-danger p-4 mt-4">
              You current plan is restricted to use this module, please Upgrade!
            </h1>
            <ChoosePlans
              onPayment={() => {
                window.location.reload();
              }}
            />
          </>
        )}
      </>
    );
  }

  const setDate = (dir) => (e) => {
    setDtFrom(getDate(dir));
  };

  const getDate = (dir) => {
    const dt = moment(dtFrom);
    if (filter.mode === 1) {
      dt.add("day", dir);
    } else if (filter.mode === 2) {
      dt.add("week", dir);
    } else if (filter.mode === 3) {
      dt.add("month", dir);
    }
    //console.log("getDate",dt.format("MMM DD, YYYY"));
    return dt;
  };

  const getStartDate = () => {
    if (filter.mode === 1) {
      return dtFrom.format("YYYY-MM-DD");
    } else if (filter.mode === 2) {
      return dtFrom.day(1).format("YYYY-MM-DD");
    } else if (filter.mode === 3) {
      return dtFrom.startOf("month").format("YYYY-MM-DD");
    }
  };

  const getDateRange = () => {
    const dt = moment(dtFrom);
    //console.log("getDateRange",dt.format("MMM DD, YYYY"));
    if (filter.mode === 1) {
      return dt.format("MMM DD, YYYY");
    } else if (filter.mode === 2) {
      return (
        dt.day(1).format("MMM DD, YYYY") +
        " - " +
        dt.day(7).format("MMM DD, YYYY")
      );
    } else if (filter.mode === 3) {
      return dt.format("MMM - YYYY");
    }
  };

  const canEditRota = (rota) => {
    return (
      userData.is_rota &&
      moment(_.get(rota, "rota_date", "")).isSameOrAfter(
        moment().startOf("day"),
      )
    );
  };

  const dupRotaUsers = (dt) => {
    let dtRotaIds = _.map(_.filter(rotas, { rota_date: dt }), (r) =>
      parseInt(r.id),
    );
    let dup = [];
    _.each(_.groupBy(rUsers, "user_id"), (rus, user_id) => {
      if (
        _.intersection(
          _.map(rus, (r) => parseInt(r.rota_id)),
          dtRotaIds,
        ).length > 1
      ) {
        dup.push(parseInt(user_id));
      }
    });
    return dup;
  };

  const renderUserName = (rota, ru) => {
    if (ru.ruser === null || ru.ruser === "") {
      return <></>;
    } else {
      let ruser = _.get(ru, "ruser", "").split("#");
      const userAvailable = ruser[1]
        .split(",")
        .includes(moment(rota.rota_date).format("E"));
      const onHoliday = (uid) => {
        const hasHolidays = ruHolidays.filter(
          (ru) => parseInt(ru.applied_by) === parseInt(uid),
        );
        const dt = moment(rota.rota_date);
        return (
          hasHolidays.filter(
            (ru) =>
              dt.isSameOrAfter(moment(ru.leave_from)) &&
              dt.isSameOrBefore(moment(ru.leave_to)),
          ).length > 0
        );
      };

      if (!userAvailable || onHoliday(ru.user_id)) {
        return <div className="alert alert-danger p-1">{ruser[0]}</div>;
      } else if (
        _.includes(dupRotaUsers(rota.rota_date), parseInt(ru.user_id))
      ) {
        return <div className="alert alert-info p-1">{ruser[0]}</div>;
      } else {
        return <div>{ruser[0]}</div>;
      }
    }
  };

  const rotaMemberCell = (uid, dt) => {
    const dtStr = moment(dt).format("YYYY-MM-DD");
    const rotarecs = _.filter(rotas, (r) => r.rota_date === dtStr);
    const ruserrecs = _.filter(
      rUsers,
      (ru) =>
        ru.user_id === uid &&
        _.map(rotarecs, (rr) => rr.id).includes(ru.rota_id),
    );
    const slots = { am: "AM", pm: "PM", fd: "Full Day" };

    const onHoliday = (uid) => {
      const hasHolidays = ruHolidays.filter(
        (ru) => parseInt(ru.applied_by) === parseInt(uid),
      );
      const dt = moment(dtStr);
      return (
        hasHolidays.filter(
          (ru) =>
            dt.isSameOrAfter(moment(ru.leave_from)) &&
            dt.isSameOrBefore(moment(ru.leave_to)),
        ).length > 0
      );
    };
    return (
      <div className="rotaCell">
        {_.map(ruserrecs, (ru) => {
          let ruser = _.get(ru, "ruser", "").split("#");
          const userAvailable = ruser[1]
            .split(",")
            .includes(moment(dtStr).format("E"));
          const rotarec = _.find(rotas, (r) => r.id === ru.rota_id);
          return (
            <div
              className={`${!userAvailable || onHoliday(ru.user_id) ? "alert alert-danger p-3" : "filled"}`}
            >
              <div className={`d-flex`}>
                <b className="flex-fill text-primary">{slots[ru.slot]}:</b>
                {canEditRota(rotarecs[0]) && (
                  <div className="text-end mb-1">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/delete.png`}
                      width="15px"
                      className="clickable"
                      style={{ marginRight: "-10px", marginTop: "-20px" }}
                      title="Delete Assigned Rota"
                      onClick={() => deleteRotaAss(ru.id)}
                    />
                  </div>
                )}
              </div>
              <div>{Utils.rotaRoom(rotarec.room_id)}</div>
              <i style={{ fontSize: "12px" }}>{rotarec.braname}</i>
              {!_.isEmpty(ru.notes) && (
                <div
                  className="clickable"
                  onClick={() =>
                    setMessage({
                      type: "info",
                      message: <pre>{ru.notes}</pre>,
                      title: "Rota Notes",
                    })
                  }
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/notes.png`}
                    width="15px"
                  />{" "}
                  {_.truncate(ru.notes, { length: 20 })}
                </div>
              )}
            </div>
          );
        })}
        {_.isEmpty(ruserrecs) && <div className="empty">Off / Unassigned</div>}
      </div>
    );
  };

  const dailyView = () => {
    return (
      <Table variant="light" hover>
        <thead>
          <tr>
            <th className="bg-primary text-white rounded-top-start px-2">
              User
            </th>
            <th className="bg-primary text-white rounded-top-end px-2">
              Room & Branch
            </th>
          </tr>
        </thead>
        <tbody>
          {getFilteredMembers().map((m, idx) => (
            <tr key={idx}>
              <td>{m.name}</td>
              <td>{rotaMemberCell(m.id, dtFrom)}</td>
            </tr>
          ))}
          {/*rotas.map((rec,idx) => <tr key={idx}>
          <td>{Utils.rotaRoom(rec.room_id)} - {rec.braname}</td>
          <td>{_.filter(rUsers,ru => ru.rota_id==rec.id && ru.slot==='fd').map(ru => renderUserName(rec,ru))}</td>
          <td>{_.filter(rUsers,ru => ru.rota_id==rec.id && ru.slot==='am').map(ru => renderUserName(rec,ru))}</td>
          <td>{_.filter(rUsers,ru => ru.rota_id==rec.id && ru.slot==='pm').map(ru => renderUserName(rec,ru))}</td>
          
        </tr>)*/}
        </tbody>
      </Table>
    );
  };

  const weeklyView = () => {
    const weekdate = (day) => moment(dtFrom.day(1)).add("day", day);

    const rotaOfTheDay = (day, bid, rid) =>
      _.find(
        rotas,
        (r) =>
          r.rota_date === weekdate(day).format("YYYY-MM-DD") &&
          r.branch_id === bid &&
          r.room_id === rid,
      );
    const rotaUsers = (slot, day, bid, rid) =>
      _.filter(
        rUsers,
        (ru) =>
          _.get(rotaOfTheDay(day, bid, rid), "id", 0) === ru.rota_id &&
          ru.slot === slot,
      );

    const brs = _.map(
      _.uniq(
        _.map(
          _.sortBy(rotas, ["branch_id", "room_id"]),
          (rr) => rr.branch_id + "," + rr.room_id,
        ),
      ),
      (rr) => rr.split(","),
    );

    return (
      <Table variant="light" hover>
        <thead>
          <tr>
            <th
              className="bg-primary text-white rounded-top-start px-2"
              style={{ minWidth: "250px" }}
            >
              User
            </th>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <th
                key={day}
                style={{ minWidth: "250px" }}
                className="bg-primary text-white px-2 text-center"
              >
                {weekdate(day).format("ddd, MMM DD")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {getFilteredMembers().map((m, idx) => (
            <tr key={idx}>
              <td>{m.name}</td>
              {[1, 2, 3, 4, 5, 6, 7].map((day) => (
                <td>
                  <div className="h-100">
                    {rotaMemberCell(
                      m.id,
                      moment(dtFrom.startOf("week")).add(day, "days"),
                    )}
                  </div>
                </td>
              ))}
            </tr>
          ))}
          {/*rotas.map((rec,idx) => <tr key={idx}>
          <td>{Utils.rotaRoom(rec.room_id)} - {rec.braname}</td>
          <td>{_.filter(rUsers,ru => ru.rota_id==rec.id && ru.slot==='fd').map(ru => renderUserName(rec,ru))}</td>
          <td>{_.filter(rUsers,ru => ru.rota_id==rec.id && ru.slot==='am').map(ru => renderUserName(rec,ru))}</td>
          <td>{_.filter(rUsers,ru => ru.rota_id==rec.id && ru.slot==='pm').map(ru => renderUserName(rec,ru))}</td>
          
        </tr>)*/}
        </tbody>
      </Table>
    );

    const bgcolors = ["#f8f8f8", "#fff"];
    return (
      <Table bordered>
        <thead>
          <tr>
            <th style={{ minWidth: "250px" }}>Room & Branch</th>
            <th style={{ minWidth: "80px" }}>Shift</th>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <th
                key={day}
                style={{ minWidth: "250px" }}
                colspan={viewOnly ? 1 : 2}
              >
                {weekdate(day).format("DD/MM/YYYY")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {brs.map(
            (br, idx) =>
              _.get(
                _.filter(
                  rotas,
                  (r) =>
                    r.branch_id === br[0] &&
                    r.room_id === br[1] &&
                    moment(r.rota_date).isBetween(weekdate(-1), weekdate(7)),
                ),
                "length",
                0,
              ) > 0 && (
                <>
                  <tr key={idx} style={{ backgroundColor: bgcolors[idx % 2] }}>
                    <td rowspan="3" style={{ border: "1px Solid #dee2e6" }}>
                      {Utils.rotaRoom(br[1])} -{" "}
                      {_.get(
                        _.find(branches, (b) => b.id === br[0]),
                        "name",
                        "unknown",
                      )}
                    </td>
                    <td>Full Day</td>
                    {[0, 1, 2, 3, 4, 5, 6].map((day) => (
                      <>
                        <td style={{ borderLeft: "1px Solid #dee2e6" }}>
                          {_.map(rotaUsers("fd", day, br[0], br[1]), (ru) => (
                            <div>
                              {renderUserName(
                                rotaOfTheDay(day, br[0], br[1]),
                                ru,
                              )}
                            </div>
                          ))}
                        </td>
                        {!viewOnly && (
                          <td
                            rowspan="3"
                            style={{
                              border: "1px Solid #dee2e6",
                              width: "50px",
                            }}
                            className="text-end"
                          ></td>
                        )}
                      </>
                    ))}
                  </tr>
                  <tr style={{ backgroundColor: bgcolors[idx % 2] }}>
                    <td>AM</td>
                    {[0, 1, 2, 3, 4, 5, 6].map((day) => (
                      <>
                        <td style={{ borderLeft: "1px Solid #dee2e6" }}>
                          {_.map(rotaUsers("am", day, br[0], br[1]), (ru) => (
                            <div>
                              {renderUserName(
                                rotaOfTheDay(day, br[0], br[1]),
                                ru,
                              )}
                            </div>
                          ))}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr style={{ backgroundColor: bgcolors[idx % 2] }}>
                    <td>PM</td>
                    {[0, 1, 2, 3, 4, 5, 6].map((day) => (
                      <>
                        <td style={{ borderLeft: "1px Solid #dee2e6" }}>
                          {_.map(rotaUsers("pm", day, br[0], br[1]), (ru) => (
                            <div>
                              {renderUserName(
                                rotaOfTheDay(day, br[0], br[1]),
                                ru,
                              )}
                            </div>
                          ))}
                        </td>
                      </>
                    ))}
                  </tr>
                </>
              ),
          )}
        </tbody>
      </Table>
    );
  };

  const gotoDate = (wdate) => (e) => {
    setFilter({ ...filter, branch: "", member: "", mode: 1 });
    setDtFrom(wdate);
  };

  const drawDateBox = (dt, sameMonth = true) => {
    if (_.isNull(dt)) {
      return (
        <Card className="m-0 p-0 monthbox monthbox-empty mr-1 my-1"></Card>
      );
    }

    const rotasOfTheDay = _.filter(
      rotas,
      (r) => r.rota_date === moment(dt).format("YYYY-MM-DD"),
    );

    return (
      <Card
        className="m-0 p-0 monthbox mr-1 my-1 clickable"
        title="Click to Daily View"
        onClick={gotoDate(moment(dt))}
      >
        <Card.Header
          className={`d-block d-md-none bg-${sameMonth ? "white" : "grey"} text-info border-info`}
        >
          <span className="monthdate">{moment(dt).format("DD")}</span>
          <span className="monthday">{moment(dt).format("dddd")}</span>
        </Card.Header>
        <div className="d-flex flex-column justify-content-center align-items-center h-100">
          {_.flatten(_.values(rotasOfTheDay)).length === 0 && (
            <div className="w-100 flex-grow-1 text-white bg-warning text-center m-2 d-flex justify-content-center align-items-center">
              Rota To Do
            </div>
          )}
          {_.flatten(_.values(rotasOfTheDay)).length > 0 && (
            <div className="w-100 flex-grow-1 text-white bg-success text-center m-2 d-flex justify-content-center align-items-center">
              Rota Complete - {rotasOfTheDay.length}
            </div>
          )}
          <div className="w-100 text-end text-info px-2">
            <b>{moment(dt).format("DD")}</b>
          </div>
        </div>
      </Card>
    );
  };

  const monthlyView = () => {
    let mdt = getStartDate();

    return (
      <>
        <Row className="d-md-none mt-2">
          {Utils.getMonthDates(mdt).map((v1) => (
            <Col xs={6} className="p-0 px-1" key={v1}>
              {drawDateBox(v1, moment(mdt).month() === moment(v1).month())}
            </Col>
          ))}
        </Row>

        <Table
          responsive
          className="h-100 d-none d-md-table"
          style={{ minHeight: "300px" }}
        >
          <tr>
            {Utils.weekdays().map((v, k) => {
              return (
                <td
                  key={k}
                  className="align-top h-100"
                  style={{ width: 100 / 7 + "%" }}
                >
                  <div className="d-flex flex-column h-100 p-0">
                    <div className="monthweek">
                      {v.substring(0, 3).toUpperCase()}
                    </div>
                    {Utils.getAllWeekDates(mdt, k + 1).map((v1) =>
                      drawDateBox(v1),
                    )}
                  </div>
                </td>
              );
            })}
          </tr>
        </Table>
      </>
    );
  };

  const renderRotaView = () => {
    const modeView = [dailyView, weeklyView, monthlyView];
    return (
      <div style={{ overflowX: "auto" }}>{modeView[filter.mode - 1]()}</div>
    );
  };

  const copyRota = () => {
    setLoading(true);
    setConfirmCopy(false);
    let pvars = `?filter[op]=${filter.op}&filter[mode]=${filter.mode}`;
    pvars += `&filter[dtf]=${dtFrom.format("YYYY-MM-DD")}&filter[branch]=${filter.branch}&filter[member]=${filter.member}`;

    axios
      .get(Utils.apiUrl("users/copyrota") + pvars, Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        setMessage({
          type: res.data.success ? "info" : "error",
          message: _.isObject(res.data.message)
            ? Object.values(res.data.message).join(",")
            : res.data.message,
        });
        if (res.data.success) {
          fetchRotas();
        }
      })
      .catch((err) => {
        setLoading(false);
        setMessage({
          type: "error",
          message: err.message,
        });
      });
  };

  const confirmCopyModal = () => {
    return (
      <Modal show={confirmCopy} onHide={() => setConfirmCopy(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Copy Rota</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            You are about to copy the Rota assignments from previous period to
            the selected cycle.
          </p>
          <p>
            <b>Are you sure you want to proceed?</b>
          </p>
        </Modal.Body>
        <Modal.Footer className="mx-auto">
          <Button variant="secondary" onClick={() => setConfirmCopy(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={copyRota}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const getDateNote = () => {
    if (notes.length > 0) {
      return _.find(
        notes,
        (nt) => nt.rota_date === dtFrom.format("YYYY-MM-DD"),
      );
    } else {
      return {};
    }
  };

  const getFilteredMembers = (filterByMember = 0) => {
    let members = [];
    members = filter.branch
      ? _.filter(
          orgMembers,
          (m) => parseInt(m.branch_id) === parseInt(filter.branch),
        )
      : orgMembers;
    if (filterByMember === 1) {
      if (filter.member) {
        members = _.filter(
          members,
          (m) => parseInt(m.id) === parseInt(filter.member),
        );
        if (filter.branch && members.length === 0) {
          members = _.filter(
            orgMembers,
            (m) => parseInt(m.branch_id) === parseInt(filter.branch),
          );
        }
      }
    }
    return members;
  };

  const getDatedRotas = () => {
    let tdata = {};
    if (filter.mode === 1 || filter.mode === 2) {
      _.fill(new Array(filter.mode === 1 ? 1 : 7), 1).map((s, i) => {
        const dt = moment(getStartDate()).add(i, "days");
        const temp_rotas = _.filter(
          rotas,
          (r) => r.rota_date === dt.format("YYYY-MM-DD"),
        );
        const temp_rusers = _.filter(rUsers, (ru) =>
          _.find(temp_rotas, (tr) => tr.id === ru.rota_id),
        );

        _.each(temp_rusers, (ru) => {
          const rota = _.find(temp_rotas, (tr) => tr.id === ru.rota_id);
          _.set(tdata, [ru.user_id, ru.slot, rota.rota_date], {
            selected: true,
            branch: rota.branch_id,
            room: rota.room_id,
            notes: ru.notes,
          });
        });
      });
      console.log(tdata);
    }

    return tdata;
  };

  return (
    <>
      <div className="mt-4 pt-4">
        <Row>
          <Col xs={9}>
            <h3 class="title">
              {viewOnly
                ? "Staff"
                : mode === 0
                  ? "Manage"
                  : mode === 2
                    ? "Edit"
                    : "Assign"}{" "}
              Rota
            </h3>
          </Col>
          <Col xs={3} className="text-end">
            {mode === 0 && filter.mode !== 3 && viewOnly === false && (
              <Button variant="success" onClick={() => setMode(1)}>
                Add +
              </Button>
            )}
            {mode > 0 && (
              <Button variant="outline-secondary" onClick={() => setMode(0)}>
                Back to View
              </Button>
            )}
          </Col>
        </Row>
        {mode === 0 && (
          <Row className="mt-3 mt-sm-4">
            <Col>
              <Form>
                <Row className="gx-1">
                  <Col className="d-none d-sm-block">
                    <Button
                      variant="light"
                      className="style1 w-100 radius-left shadow-cst filters"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/filter.png`}
                        className="me-0 me-lg-3"
                        alt="Filter"
                      />{" "}
                      Filter
                    </Button>
                  </Col>
                  <Col>
                    <select
                      className="form-control form-control-select form-select shadow-cst filters"
                      value={filter.branch}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          branch: e.currentTarget.value,
                        })
                      }
                    >
                      <option value="">All Branches</option>
                      {branches.map((b) => (
                        <option value={b.id}>{b.name}</option>
                      ))}
                    </select>
                  </Col>
                  <Col className="d-none d-sm-block">
                    <select
                      className="form-control form-control-select form-select shadow-cst filters"
                      value={filter.member}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          member: e.currentTarget.value,
                        })
                      }
                    >
                      <option value="">All Members</option>
                      {getFilteredMembers(0).map((m) => (
                        <option value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </Col>

                  <Col className="col-3">
                    <Button
                      variant="light"
                      className="style1 w-100 radius-right shadow-cst p-0 filters"
                      onClick={(e) =>
                        setFilter({ ...filter, member: "", branch: "" })
                      }
                    >
                      Clear filter
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        )}

        {/*mode !== 0 && <RotaForm mode={mode} data={selectedRota} defaultDate={dtFrom} branches={branches} orgMembers={orgMembers} afterSave={afterSave} onHide={() => setMode(0)} />*/}

        {mode !== 0 && (
          <RotaAssignment
            mode={filter.mode}
            data={getDatedRotas()}
            defaultDate={dtFrom}
            defBranch={_.get(filter, "branch", "")}
            branches={branches}
            orgMembers={() => getFilteredMembers(1)}
            afterSave={afterSave}
            onHide={() => setMode(0)}
          />
        )}

        {mode === 0 && (
          <>
            <Row className="mt-3 mt-sm-4">
              <Col>
                <Row className="d-sm-none">
                  <Col xs={4} className="m-0 p-0 ps-3">
                    <Button
                      variant={`${filter.mode === 1 ? "primary" : "light"}`}
                      className="w-100 rounded-0 roundleft"
                      onClick={(e) => {
                        setFilter({ ...filter, mode: 1 });
                        setDtFrom(moment());
                      }}
                    >
                      Daily
                    </Button>
                  </Col>
                  <Col xs={4} className="m-0 p-0">
                    <Button
                      variant={`${filter.mode === 2 ? "primary" : "light"}`}
                      className="w-100 rounded-0"
                      onClick={(e) => {
                        setFilter({ ...filter, mode: 2 });
                      }}
                    >
                      Weekly
                    </Button>
                  </Col>
                  <Col xs={4} className="m-0 p-0 pe-3">
                    <Button
                      variant={`${filter.mode === 3 ? "primary" : "light"}`}
                      className="w-100 rounded-0 roundright"
                      onClick={(e) => {
                        setFilter({ ...filter, mode: 3 });
                      }}
                    >
                      Monthly
                    </Button>
                  </Col>
                </Row>

                <Card className="shadow table-section p-sm-3 border-0 bottomRoundedBox mx-1 mx-sm-0">
                  <Card.Body>
                    <Row>
                      <Col className="d-flex justify-content-between">
                        <div className="d-flex">
                          <div>
                            <ButtonGroup
                              aria-label="Basic example"
                              className="shadow btn-group order-3 order-lg-1 d-none d-lg-block d-xl-block"
                            >
                              <Button
                                variant="light"
                                className="radius-left"
                                onClick={setDate(-1)}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/arrow-left.png`}
                                  alt="Previous"
                                />
                              </Button>
                              <Button variant="primary">
                                {" "}
                                {getDateRange()}{" "}
                              </Button>
                              <Button
                                variant="light"
                                className="radius-right"
                                onClick={setDate(1)}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/arrow-right.png`}
                                  alt="Next"
                                />
                              </Button>
                            </ButtonGroup>
                          </div>
                          {mode === 0 &&
                            filter.mode !== 3 &&
                            viewOnly === false &&
                            moment(dtFrom).isSameOrAfter(
                              moment().startOf("day"),
                            ) && (
                              <>
                                {rotas.length > 0 && (
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/edit.png`}
                                    className="clickable mx-3 my-auto"
                                    title={`Edit Rotas for ${getDateRange()}`}
                                    onClick={() => setMode(2)}
                                  />
                                )}
                              </>
                            )}
                        </div>

                        <div className="d-none d-sm-inline order-1 order-lg-3 flex-xs-fill">
                          {showCopy && !viewOnly && (
                            <span className="d-none d-sm-inline">
                              <Button
                                variant="warning"
                                className="me-4 shadow clickable"
                                onClick={() => setConfirmCopy(true)}
                              >
                                Copy Previous Cycle
                              </Button>
                            </span>
                          )}
                          <ButtonGroup
                            aria-label="Basic example"
                            className="shadow btn-group"
                          >
                            <Button
                              variant={`${filter.mode === 1 ? "primary" : "light"}`}
                              className="radius-left"
                              onClick={(e) => {
                                setFilter({ ...filter, mode: 1 });
                                setDtFrom(moment());
                              }}
                            >
                              Daily
                            </Button>
                            <Button
                              variant={`${filter.mode === 2 ? "primary" : "light"}`}
                              className=""
                              onClick={(e) => {
                                setFilter({ ...filter, mode: 2 });
                              }}
                            >
                              Weekly
                            </Button>
                            <Button
                              variant={`${filter.mode === 3 ? "primary" : "light"}`}
                              className="radius-right"
                              onClick={(e) => {
                                setFilter({ ...filter, mode: 3 });
                              }}
                            >
                              Monthly
                            </Button>
                          </ButtonGroup>
                        </div>
                      </Col>
                    </Row>

                    <div className="mt-sm-4">
                      <Row className="d-sm-none d-block">
                        <Col className="d-flex justify-content-center">
                          <ButtonGroup
                            aria-label="Basic example"
                            className="shadow btn-group"
                          >
                            <Button
                              variant="light"
                              className="radius-left"
                              onClick={setDate(-1)}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/images/arrow-left.png`}
                                alt="Previous"
                              />
                            </Button>
                            <Button variant="primary">
                              {" "}
                              {getDateRange()}{" "}
                            </Button>
                            <Button
                              variant="light"
                              className="radius-right"
                              onClick={setDate(1)}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/images/arrow-right.png`}
                                alt="Next"
                              />
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>

                      {loading && (
                        <Alert variant="info" className="p-3">
                          <p className="loading-msg">Fetching Rota..</p>
                          <ProgressBar variant="info" animated now={100} />
                        </Alert>
                      )}
                      {loading === false && (
                        <>
                          {showCopy && (
                            <div className="text-center p-4 d-block d-sm-none">
                              <Button
                                variant="warning"
                                className="shadow clickable"
                                onClick={() => setConfirmCopy(true)}
                              >
                                Copy Previous Cycle
                              </Button>
                            </div>
                          )}
                          {rotas.length === 0 && (
                            <div className="alert alert-warning p-5 text-center mt-4">
                              No Rota added yet!
                            </div>
                          )}
                          {rotas.length > 0 && renderRotaView()}
                        </>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {confirmCopy && confirmCopyModal()}
          </>
        )}
      </div>

      {message && (
        <MessageModal
          {...message}
          onHide={() => {
            setMessage(false);
          }}
        />
      )}
    </>
  );
};

export default Rota;
